const params = window.configObj || {};

const get = key => {
    return params[key];
};

module.exports = { get };
